/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { partnerAdminControllerCreateV1 } from '../fn/partner-admin/partner-admin-controller-create-v-1';
import { PartnerAdminControllerCreateV1$Params } from '../fn/partner-admin/partner-admin-controller-create-v-1';
import { partnerAdminControllerDeleteV1 } from '../fn/partner-admin/partner-admin-controller-delete-v-1';
import { PartnerAdminControllerDeleteV1$Params } from '../fn/partner-admin/partner-admin-controller-delete-v-1';
import { partnerAdminControllerFindAllV1 } from '../fn/partner-admin/partner-admin-controller-find-all-v-1';
import { PartnerAdminControllerFindAllV1$Params } from '../fn/partner-admin/partner-admin-controller-find-all-v-1';
import { partnerAdminControllerFindByIdV1 } from '../fn/partner-admin/partner-admin-controller-find-by-id-v-1';
import { PartnerAdminControllerFindByIdV1$Params } from '../fn/partner-admin/partner-admin-controller-find-by-id-v-1';
import { partnerAdminControllerReorderV1 } from '../fn/partner-admin/partner-admin-controller-reorder-v-1';
import { PartnerAdminControllerReorderV1$Params } from '../fn/partner-admin/partner-admin-controller-reorder-v-1';
import { partnerAdminControllerSearchCursorV1 } from '../fn/partner-admin/partner-admin-controller-search-cursor-v-1';
import { PartnerAdminControllerSearchCursorV1$Params } from '../fn/partner-admin/partner-admin-controller-search-cursor-v-1';
import { partnerAdminControllerSearchOffsetV1 } from '../fn/partner-admin/partner-admin-controller-search-offset-v-1';
import { PartnerAdminControllerSearchOffsetV1$Params } from '../fn/partner-admin/partner-admin-controller-search-offset-v-1';
import { partnerAdminControllerUpdateV1 } from '../fn/partner-admin/partner-admin-controller-update-v-1';
import { PartnerAdminControllerUpdateV1$Params } from '../fn/partner-admin/partner-admin-controller-update-v-1';
import { PartnerDto } from '../models/partner-dto';

@Injectable({ providedIn: 'root' })
export class PartnerAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `partnerAdminControllerFindAllV1()` */
  static readonly PartnerAdminControllerFindAllV1Path = '/api/v1/partners/admin';

  /**
   * 파트너 전체 조회.
   *
   * 파트너 목록을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerAdminControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerAdminControllerFindAllV1$Response(params?: PartnerAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PartnerDto>>> {
    const obs = partnerAdminControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파트너 전체 조회.
   *
   * 파트너 목록을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerAdminControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerAdminControllerFindAllV1(params?: PartnerAdminControllerFindAllV1$Params, context?: HttpContext): Observable<Array<PartnerDto>> {
    const resp = this.partnerAdminControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PartnerDto>>): Array<PartnerDto> => r.body)
    );
  }

  /** Path part for operation `partnerAdminControllerCreateV1()` */
  static readonly PartnerAdminControllerCreateV1Path = '/api/v1/partners/admin';

  /**
   * 파트너 생성.
   *
   * 파트너를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnerAdminControllerCreateV1$Response(params: PartnerAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerDto>> {
    const obs = partnerAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파트너 생성.
   *
   * 파트너를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnerAdminControllerCreateV1(params: PartnerAdminControllerCreateV1$Params, context?: HttpContext): Observable<PartnerDto> {
    const resp = this.partnerAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PartnerDto>): PartnerDto => r.body)
    );
  }

  /** Path part for operation `partnerAdminControllerSearchOffsetV1()` */
  static readonly PartnerAdminControllerSearchOffsetV1Path = '/api/v1/partners/admin/search/offset';

  /**
   * 파트너 오프셋 검색.
   *
   * 파트너를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerAdminControllerSearchOffsetV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerAdminControllerSearchOffsetV1$Response(params: PartnerAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<PartnerDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = partnerAdminControllerSearchOffsetV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파트너 오프셋 검색.
   *
   * 파트너를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerAdminControllerSearchOffsetV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerAdminControllerSearchOffsetV1(params: PartnerAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<{
'items': Array<PartnerDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.partnerAdminControllerSearchOffsetV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<PartnerDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<PartnerDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `partnerAdminControllerSearchCursorV1()` */
  static readonly PartnerAdminControllerSearchCursorV1Path = '/api/v1/partners/admin/search/cursor';

  /**
   * 파트너 커서 검색.
   *
   * 파트너를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerAdminControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerAdminControllerSearchCursorV1$Response(params: PartnerAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<PartnerDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>> {
    const obs = partnerAdminControllerSearchCursorV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파트너 커서 검색.
   *
   * 파트너를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerAdminControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerAdminControllerSearchCursorV1(params: PartnerAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<{
'items': Array<PartnerDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}> {
    const resp = this.partnerAdminControllerSearchCursorV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<PartnerDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>): {
'items': Array<PartnerDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
} => r.body)
    );
  }

  /** Path part for operation `partnerAdminControllerFindByIdV1()` */
  static readonly PartnerAdminControllerFindByIdV1Path = '/api/v1/partners/admin/{id}';

  /**
   * 파트너 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerAdminControllerFindByIdV1$Response(params: PartnerAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerDto>> {
    const obs = partnerAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파트너 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerAdminControllerFindByIdV1(params: PartnerAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<PartnerDto> {
    const resp = this.partnerAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PartnerDto>): PartnerDto => r.body)
    );
  }

  /** Path part for operation `partnerAdminControllerDeleteV1()` */
  static readonly PartnerAdminControllerDeleteV1Path = '/api/v1/partners/admin/{id}';

  /**
   * 파트너 삭제.
   *
   * 파트너를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerAdminControllerDeleteV1$Response(params: PartnerAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerDto>> {
    const obs = partnerAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파트너 삭제.
   *
   * 파트너를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  partnerAdminControllerDeleteV1(params: PartnerAdminControllerDeleteV1$Params, context?: HttpContext): Observable<PartnerDto> {
    const resp = this.partnerAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PartnerDto>): PartnerDto => r.body)
    );
  }

  /** Path part for operation `partnerAdminControllerUpdateV1()` */
  static readonly PartnerAdminControllerUpdateV1Path = '/api/v1/partners/admin/{id}';

  /**
   * 파트너 수정.
   *
   * 파트너를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnerAdminControllerUpdateV1$Response(params: PartnerAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerDto>> {
    const obs = partnerAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파트너 수정.
   *
   * 파트너를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnerAdminControllerUpdateV1(params: PartnerAdminControllerUpdateV1$Params, context?: HttpContext): Observable<PartnerDto> {
    const resp = this.partnerAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PartnerDto>): PartnerDto => r.body)
    );
  }

  /** Path part for operation `partnerAdminControllerReorderV1()` */
  static readonly PartnerAdminControllerReorderV1Path = '/api/v1/partners/admin/reorder';

  /**
   * 파트너 순서 변경.
   *
   * 파트너 노출 순서를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `partnerAdminControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnerAdminControllerReorderV1$Response(params: PartnerAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = partnerAdminControllerReorderV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 파트너 순서 변경.
   *
   * 파트너 노출 순서를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `partnerAdminControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  partnerAdminControllerReorderV1(params: PartnerAdminControllerReorderV1$Params, context?: HttpContext): Observable<void> {
    const resp = this.partnerAdminControllerReorderV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
